import React, { useEffect, useState } from 'react'
import classes from "../../styles.module.css";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import TitleSection from '../../../../common/TitleSection';
import styles from "../../../../ContentStyling.module.css";

const FeettoCm = () => {
    const [inputValue, setInputValue] = useState();
    const [outputValue, setOutputValue] = useState();
    const [errorMessage, setErrorMessage] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        // Initialize Google Ads
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({});
          console.error("AdSense run successfully");
        } catch (e) {
          console.error("AdSense error", e);
        }
      }, []);

      const convertFeetToCm = () => {
        // Validate input: allow numbers, decimals, and optional minus sign
        if (!/^-?\d+(\.\d+)?$/.test(inputValue)) {
            setErrorMessage("Please enter a valid length in feet (e.g., 5, 6.25).");
            setOutputValue("");
            return;
        }

        setErrorMessage("");
        const feetValue = parseFloat(inputValue); // Convert input string to a number
        const cmValue = feetValue * 30.48; // 1 foot = 30.48 cm
        setOutputValue(cmValue.toFixed(6)); // Limit output to 6 decimal places
    };




      const handleClearBtn = () => {
        setInputValue("");
        setOutputValue("");
        setErrorMessage("");
      }

      const handleSwapClick = () => {
        navigate("/converters/cm-to-feet");
    };

        

  return (
    <div className={classes.page}>
      <Helmet>
                <title>Feet to CM Converter - Wiraa tools</title>
                <meta name="description" content="Easily convert feet to CM using our online conversion tool. Accurate results with simple calculations for your length measurements. Try now!" />
        </Helmet>
    <div className={classes.container}>
      <TitleSection
              icon="https://cdn-icons-png.flaticon.com/128/570/570968.png"
              title="Feet To CM Converter"
              subTitle="Effortlessly Convert Feet To CM for Accurate Measurements"
            />
      <div className={classes.innerCon}>
        <div className={classes.inputCon}>
            <p className={classes.inputplaceholder}>Feet Value</p>
            <input value={inputValue} onChange={(e) => setInputValue(e.target.value)} className={classes.inputfield} placeholder='Enter feet value'/>
            {errorMessage && <p className={classes.errorMsg}>{errorMessage}</p>}
        </div>
        <div className={classes.btnCon}>
            <button className={classes.convertBtn} onClick={convertFeetToCm}>Convert</button>
            <button className={classes.clearBtn} onClick={handleClearBtn}>Clear</button>
            <button className={classes.swapBtn} onClick={handleSwapClick}>Swap</button>
        </div>
        <div className={classes.outputCon}>
            <p className={classes.outputplaceholder}>CM Value</p>
            <p className={classes.outputfield}>{outputValue}</p>
        </div>
      </div>
      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>
     <div className={styles.contentContainer}>
      <p>The Feet to CM Converter is a practical tool for professionals, students, and anyone needing to convert imperial measurements into metric. This tool helps you quickly and accurately convert feet (ft) into centimeters (cm) perfect for design, construction, height conversion, and global compatibility.</p>
      <p>Whether you're working on a building plan, measuring a person’s height, or reading international product specs, this converter ensures smooth and precise conversions.</p>
      <h3>What Are Feet and Centimeters?</h3>
      <p><b>Feet (ft): </b>A unit of length in the imperial system. Commonly used in the United States, 1 foot equals 12 inches. <br /> 1 foot = 30.48 centimeters</p>
      <p><b>Centimeters (cm): </b> A unit of length in the metric system. Used widely across the world for everyday and professional measurements. <br />1 cm = 0.0328084 feet</p>
      <h3>Why Convert Feet to CM?</h3>
      <ul>
        <li><b>Global Compatibility:</b> Metric units are standard in most countries, industries, and scientific work.</li>
        <li><b>Accuracy:</b> Essential for creating precise measurements when working internationally.</li>
        <li><b>Standardization:</b> Helps ensure consistency in technical documents, blueprints, and size charts.</li>
      </ul>
      <h3>How to Use the Feet to CM Converter</h3>
      <ol>
        <li><b>Enter Feet Value:</b> Input the length in feet.</li>
        <li><b>Click Convert:</b> The tool calculates and displays the equivalent in centimeters.</li>
        <li><b>Use the Result:</b> Apply the result in construction plans, health records, or product dimensions.</li>
      </ol>
      <h3>Conversion Examples</h3>
      <ul>
        <li>1 ft → 30.48 cm</li>
        <li>5 ft → 152.4 cm</li>
        <li>6.2 ft → 188.98 cm</li>
        <li>10 ft → 304.8 cm</li>
      </ul>
      <h3>Benefits of Using Feet to CM Converter</h3>
      <ul>
        <li><b>Fast Results:</b> Converts values instantly.</li>
        <li><b>High Accuracy:</b> Uses the exact conversion factor for precise results.</li>
        <li><b>No Manual Calculation:</b> Saves time and reduces errors.</li>
      </ul>
      <h3>Who Can Use This Tool?</h3>
      <p>This converter is designed for everyone who deals with measurements across imperial and metric systems. Especially useful for:</p>
      <ul>
        <li><b>Architects & Engineers:</b> For drafting international plans and diagrams.</li>
        <li><b>Health & Fitness Professionals:</b> For converting height and body measurements.</li>
        <li><b>Online Retailers:</b> To show product sizes clearly for global customers.</li>
        <li><b>Students & Teachers:</b> For educational and math-related purposes.</li>
      </ul>
     </div>
    </div>
   </div>
  )
}

export default FeettoCm;
